module.exports = __webpack_public_path__ + "img/2.c77688ac.jpg";